<template>
  <div class="mask-layer">
    <div class="container ">
      <div class="title">事故车推送</div>
      <div class="content">
        <div class="topInfo">
          <span class="mr26"><i class="sign mr8">*</i>所属公司：{{sendData.companyName}}</span>
          <span><i class="sign mr8">*</i>公司ID：{{sendData.companyId}}</span>
        </div>
        <div class="sendInfo">
          <span><i class="sign mr8">*</i>推送信息</span>
        </div>
        <div class="infoZone">
          <!--<p>{{copy}}</p>-->
          <!--<textarea name="" id="" cols="30" rows="10" disabled style="box-sizing: border-box;padding: 20px;">-->
            <!--{{code}}-->
          <!--</textarea>-->
          <p>您好，这里是救援大师调度中心，今天往贵店新推送了一辆事故车，信息如下：</p>
          <p>车牌号：{{sendData.carNumer}}</p>
          <p>车辆品牌：{{sendData.carBrandName}}</p>
          <p>车主姓名：{{sendData.carOwnerName}}</p>
          <p>车主电话：{{sendData.carOwnerPhone}}</p>
          <p>请及时联系客户，并反馈沟通结果，方便后续跟进，谢谢！</p>
          <p>订单详情：</p>
          <p style="word-break: break-all;">
            <a :href='link' target="_blank">{{link}}</a>
          </p>
          <!--<p></p>-->
          <button  v-clipboard:copy="code"
                   v-clipboard:success="onCopy"
                   v-clipboard:error="onError">复制</button>
        </div>
      </div>
      <div class="close" @click="close">X</div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "send-mask",
    props:['sendData'],
    data() {
      return {
        link:null,
      }
    },
    mounted() {
    },
    computed:{
      code(){
        var carNumber=this.sendData.carNumer;
        var carBrandName=this.sendData.carBrandName;
        var carOwnerName=this.sendData.carOwnerName;
        var carOwnerPhone=this.sendData.carOwnerPhone;
        // var link='http://fx.jiuyuandashi.com.cn/sendAccidentCar?storeId='+this.sendData.storeId+'&orderId='+this.sendData.orderId;
        var link=this.SHARE_SERVER+'/sendAccidentCar/'+this.sendData.storeId+'/'+this.sendData.orderId;
        this.link=link;
        // return`
        // 您好，这里是救援大师调度中心，今天往贵店新推送了一辆事故车，信息如下：
        // 车牌号：${carNumber}
        // 车辆品牌：${carBrandName}
        // 车主电话：${carOwnerPhone}
        // 请及时联系客户，并反馈沟通结果，方便后续跟进，谢谢！
        // 订单详情：${link}
        // `
        return '您好，这里是救援大师调度中心，今天往贵店新推送了一辆事故车，信息如下：'+' \n'+'车牌号：'+carNumber+' \n'+'车辆品牌：'+carBrandName+' \n'+'车主姓名：'+carOwnerName+' \n'+'车主电话：'+carOwnerPhone+' \n'+'请及时联系客户，并群内反馈沟通结果，方便后续跟进，谢谢！'+' \n'+'订单详情：'+' \n'+link
      }
    },
    methods: {
      close(){
        this.$emit('hideSendMask')
      },
      onCopy: function (e) {
        this.$message.success("复制成功");
      },
      onError: function (e) {
        this.$message.error("复制失败，请重新复制");
      },
    }
  }
</script>

<style scoped lang="scss">
  .mask-layer {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .container {
    background-color: #fff;
    width: 600px;
    height: 420px;
    position: relative;
    .close{
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 14px;
      position: absolute;
      top: 10px;
      right: 5px;
      cursor: pointer;
    }
    .title{
      height: 41px;
      line-height:41px;
      box-sizing: border-box;
      padding-left: 16px;
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #4A4A4A;
      text-align: left;
      border-bottom: 1px solid #ECF1F4;
    }
    .content{
      padding: 16px;
      box-sizing: border-box;
      .topInfo{
        display: flex;
        justify-content: left;
        margin-bottom: 27px;
        span{
          line-height: 21px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #000000;
        }
      }
      .sendInfo{
        display: flex;
        justify-content: left;
        margin-bottom: 10px;
        span{
          line-height: 21px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #000000;
        }
      }
      .infoZone{
        width: 568px;
        height: 250px;
        border: 1px solid #D7D7D7;
        border-radius: 2px;
        position: absolute;
        text-align: left;
        box-sizing: border-box;
        padding: 11px 20px;
        p{
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #4A4A4A;
          a{
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #FF4C00;
          }
        }
        .p1{
          margin-bottom:25px ;
        }
        .p2{
          margin-bottom:11px ;
        }
        .p3{
          margin-bottom:7.5px ;
        }
        textarea{
          position: absolute;
          left: 0;
          top: 0px;
          width: 100%;
          height: 100%;
          resize: none;
          box-sizing: border-box;
          /*padding: 0px 22px;*/
        }
        button{
          position: absolute;
          right:14px ;
          bottom: 9.5px;
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #FFFFFF;
          background: #1038B7;
          border-radius: 2px;
          padding: 2px 12px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// sendMask.vue?910388a8